import JsEvent from '@rotomeca/event';
import BnumElement from 'components/bnum-element';
import { EVENT_DEFAULT } from 'core/utils/constants/constants';

function _baseInitializer<
	TCaller extends BnumElement,
	TCallback extends (sender: TCaller) => void,
	TEvent extends JsEvent<TCallback>,
>(event: TEvent, instance: TCaller, eventName: string) {
	event.add(EVENT_DEFAULT, ((sender: TCaller) => {
		instance.trigger(eventName, { caller: sender });
	}) as TCallback);
}

export function OnSenderChangedInitializer<
	TCaller extends BnumElement,
	TCallback extends (sender: TCaller) => void,
	TEvent extends JsEvent<TCallback>,
>(event: TEvent, instance: TCaller) {
	_baseInitializer(event, instance, 'bnum-card-item-mail:sender-changed');
}

export function OnSubjectChangedInitializer<
	TCaller extends BnumElement,
	TCallback extends (sender: TCaller) => void,
	TEvent extends JsEvent<TCallback>,
>(event: TEvent, instance: TCaller) {
	_baseInitializer(event, instance, 'bnum-card-item-mail:subject-changed');
}

export function OnDateChangedInitializer<
	TCaller extends BnumElement,
	TCallback extends (sender: TCaller) => void,
	TEvent extends JsEvent<TCallback>,
>(event: TEvent, instance: TCaller) {
	_baseInitializer(event, instance, 'bnum-card-item-mail:date-changed');
}
